module.exports = __webpack_public_path__ + "img/zm.37586be9.svg";